var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75538 16.8208C2.89782 16.0161 0 12.5964 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5C17 12.073 14.7955 15.1311 11.6724 16.3882C11.6102 16.5562 11.4985 16.7127 11.3308 16.8385L7.56971 19.6593C6.75072 20.2735 5.6473 19.4063 6.05057 18.4653L6.75538 16.8208Z",
    fill: "#691FB2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSystem);
export default __webpack_public_path__ + "static/media/icon_system.734db191e1648f6a8aefd992449fe2cc.svg";
export { ForwardRef as ReactComponent };